// src/scripts/audits/shared/managersOfficeSection.js

const managersOfficeItems = [
  { key: "a1", label: "Clean & Tidy" },
  { key: "a2", label: "All files up to date" },
  { key: "a3", label: "Licensing folder complete & up-to-date" },
  { key: "a4", label: "Fire folder complete & up to date" },
  { key: "a5", label: "Health & Safety folder complete up to date" },
  { key: "a6", label: "Security folder complete & up to date" },
  { key: "a7", label: "Pre-Brief/Debrief" },
  { key: "a8", label: "Float Check" },
  { key: "a9", label: "CCTV 31 days recording" },
  { key: "a10", label: "All cameras working & burning correctly" },
  { key: "a11", label: "Float Check record" },
  { key: "a12", label: "Computers working" },
  { key: "a13", label: "Radios Charging" },
  { key: "a14", label: "Homebase software completed" },
  { key: "a15", label: "Safe protocol" },
  { key: "a16", label: "No broken PDQ machines" },
  { key: "a17", label: "Body camera footage saved to drive (Incidents)" },
  { key: "a18", label: "Incident reports completed correctly" },
  { key: "a19", label: "Photos Uploaded & taken to Standard" },
];

export function buildManagersOfficeSection() {
  return {
    id: "managersOffice",
    title: "Managers Office",
    icon: "assignment",
    items: managersOfficeItems.map((item) => ({ ...item })),
  };
}